interface ISvgPhoneProps {
    height: number | string;
    width: number | string;
    color: string;
}

const SvgPhone: React.FC<ISvgPhoneProps> = (props) => {
    return (
        <svg width={props.width} height={props.height} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                opacity="0"
                d="M31.6666 29.1166C30.2 29 28.75 28.75 27.3333 28.3666L25.35 30.35C27.35 31.0333 29.4833 31.4666 31.6833 31.6V29.1166H31.6666ZM8.3833 8.33331C8.5333 10.5333 8.96663 12.65 9.6333 14.6666L11.6333 12.6666C11.25 11.2666 11 9.81665 10.9 8.33331H8.3833Z"
                fill={props.color}
            />
            <path
                d="M15.1167 12.6167C14.5 10.75 14.1667 8.75 14.1667 6.66667C14.1667 5.75 13.4167 5 12.5 5H6.66667C5.75 5 5 5.75 5 6.66667C5 22.3167 17.6833 35 33.3333 35C34.25 35 35 34.25 35 33.3333V27.5167C35 26.6 34.25 25.85 33.3333 25.85C31.2667 25.85 29.25 25.5167 27.3833 24.9C27.2167 24.8333 27.0333 24.8167 26.8667 24.8167C26.4333 24.8167 26.0167 24.9833 25.6833 25.3L22.0167 28.9667C17.3 26.55 13.4333 22.7 11.0333 17.9833L14.7 14.3167C15.1667 13.85 15.3 13.2 15.1167 12.6167V12.6167ZM27.3333 28.3667C28.75 28.7667 30.2 29.0167 31.6667 29.1167V31.6C29.4667 31.45 27.35 31.0167 25.3333 30.35L27.3333 28.3667V28.3667ZM9.65 14.6667C8.96667 12.65 8.53333 10.5333 8.38333 8.33333H10.8833C11 9.81667 11.25 11.2667 11.65 12.65L9.65 14.6667Z"
                fill={props.color}
            />
        </svg>
    );
};

export default SvgPhone;
